<template>
  <div>
  <el-row>
    <el-col :span=8>
      <div class="size">
        <div class="title">
          {{'设备状态'}}
        </div>
        <div v-loading="eqStatusLoading" element-loading-text="数据加载中" style="width: 470px;height: 260px" id="eqStatusAccumulate"/>
      </div>
    </el-col>


    <el-col :span=8>
      <div class="size">
        <div class="title">
          {{'部门设备数'}}
        </div>
        <div v-loading="eqDeptCntLoading" element-loading-text="数据加载中" style="width: 470px;height: 260px" id="eqDeptCntAccumulate"/>
      </div>
    </el-col>

    <el-col :span=8>
      <div class="size">
        <div class="title">
          {{'各类型设备数'}}
        </div>
        <div v-loading="eqTypeLoading" element-loading-text="数据加载中" style="width: 470px;height: 260px" id="eqTypeAccumulate"/>
      </div>
    </el-col>
  </el-row>

    <div class="size">
      <div class="title">
        {{'设备维修月表'}}
        <div class="space-between">
          <el-date-picker v-model="eqRepair.day" @change="getEqRepairChart" format="YYYY 年 M 月"
                                                               value-format="YYYY-M-1" type="month" placeholder="选择月份" style="width: 140px;" :clearable="false"/>
        </div>
      </div>
      <div v-loading="eqRepairLoading" element-loading-text="数据加载中" style="width: 80%;height: 260px" id="eqRepairAccumulate"/>
    </div>
  </div>


</template>

<script>
import * as echarts from "echarts";
export default {
  name: "EqPageHomeZhiZao",
  data() {
    return {
      //设备状态
      eqStatusLoading: false,
      optionEqStatus: {
        title: {
          text: '合计',
          top: '38%',
          left: '49%',
          textAlign: 'center',
          textStyle: {
            fontSize: 16
          }
        },
        graphic: {
          type: 'text',
          left: 'center',
          top: '50%',
          style: {
            text: '',
            textAlign: 'center',
            fill: 'rgb(0,0,0)',
            fontSize: 16,
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c}, {d}%'
        },
        legend: {
          type: 'scroll',
          top: '5%',
          left: 'center',
        },
        series: [
          {
            type: 'pie',
            radius: ['30%', '50%'],
            avoidLabelOverlap: false,
            label: {
              show: true,
              position: 'center',
              normal: {
                formatter: '{b}: {d}%'
              }
            },
            labelLine: {
              show: true
            },
            data: []
          }
        ]
      },

      //部门设备
      eqDeptCntLoading : false,
      optionEqDeptCnt:{
        title:{
          text:'合计',
          top:'38%',
          left:'49%',
          textAlign: 'center',
          textStyle:{
            fontSize:16
          }
        },
        graphic: {
          type: 'text',
          left: 'center',
          top: '50%',
          style: {
            text: '',
            textAlign: 'center',
            fill: 'rgb(0,0,0)',
            fontSize: 16,
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c}, {d}%'
        },
        legend: {
          type: 'scroll',
          top: '5%',
          left: 'center',
        },
        series: [
          {
            type: 'pie',
            radius: ['30%', '50%'],
            avoidLabelOverlap: false,
            label: {
              show: true,
              position: 'center',
              normal: {
                formatter: '{b}: {d}%'
              }
            },
            labelLine: {
              show: true
            },
            data: [

            ]
          }
        ]
      },

      //各类型设备数
      eqTypeLoading : false,
      optionEqType:{
        title:{
          text:'合计',
          top:'38%',
          left:'49%',
          textAlign: 'center',
          textStyle:{
            fontSize:16
          }
        },
        graphic: {
          type: 'text',
          left: 'center',
          top: '50%',
          style: {
            text: '',
            textAlign: 'center',
            fill: 'rgb(0,0,0)',
            fontSize: 16,
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c}, {d}%'
        },
        legend: {
          type: 'scroll',
          top: '5%',
          left: 'center',
        },
        series: [
          {
            type: 'pie',
            radius: ['30%', '50%'],
            avoidLabelOverlap: false,
            label: {
              show: true,
              position: 'center',
              normal: {
                formatter: '{b}: {d}%'
              }
            },
            labelLine: {
              show: true
            },
            data: [

            ]
          }
        ]
      },

      //设备维修月报
      eqRepairLoading : false,
      eqRepair:{
        day: this.getDateFormat(),
      },
      optionEqRepair :{
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: []
          }
        ],
        yAxis: [
          {
            type: 'value'
          },
          {
            type: 'value',
            axisLabel: {
              formatter: '{value} %'
            }
          }
        ],
        series: [
          {
            name: '完成',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: '未完成',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: '完成率(%)',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + ' %';
              }
            },
            data: []
          },
        ]
      },

    }
  },
  methods: {
     async getEqStatusChart() {
       this.eqStatusLoading = true
       await this.$http('eqHomePageZhiZaoService.getEqStatusChart',{}, false).then(data => {
         //console.log("data==",data)
        this.optionEqStatus.series[0].data = data
        this.optionEqStatus.graphic.style.text = this.$sysMethod.getPieSum(this.optionEqStatus.series[0].data)
      }, errMsg => {
        this.eqStatusLoading = false
        return this.$message.error(errMsg);
      })

       this.renderEcharts('eqStatusAccumulate',this.optionEqStatus)
       this.eqStatusLoading = false
    },
    async getEqDeptChart() {
      this.eqDeptCntLoading = true
      await this.$http('eqHomePageZhiZaoService.getEqDeptChart',{}, false).then(data => {
        this.optionEqDeptCnt.series[0].data = data
        this.optionEqDeptCnt.graphic.style.text = this.$sysMethod.getPieSum(this.optionEqDeptCnt.series[0].data)
      }, errMsg => {
        this.eqDeptCntLoading = false
        return this.$message.error(errMsg);
      })
      
      this.renderEcharts('eqDeptCntAccumulate',this.optionEqDeptCnt)
      this.eqDeptCntLoading = false
    },
    async getEqTypeChart() {
      this.eqTypeLoading = true
      await this.$http('eqHomePageZhiZaoService.getEqTypeChart',{}, false).then(data => {
        this.optionEqType.series[0].data = data
        this.optionEqType.graphic.style.text = this.$sysMethod.getPieSum(this.optionEqType.series[0].data)
      }, errMsg => {
        this.eqTypeLoading = false
        return this.$message.error(errMsg);
      })
      this.renderEcharts('eqTypeAccumulate',this.optionEqType)
      this.eqTypeLoading = false
    },

    getDateFormat() {
      let month = new Date().getMonth() + 1
      return new Date().getUTCFullYear().toString() + "-" + month.toString() + "-1"
    },

    async getEqRepairChart() {
      this.eqRepairLoading = true
      await this.$http('eqHomePageZhiZaoService.getEqRepairChart',this.eqRepair, false).then(data => {
        this.optionEqRepair.xAxis[0].data = data.dateList
        this.optionEqRepair.series[0].data = data.finishList
        this.optionEqRepair.series[1].data = data.notFinishList
        this.optionEqRepair.series[2].data = data.rateList

        let a = this.$sysMethod.getDivisor(Math.max(...data.totalList))
        let b = this.$sysMethod.getDivisor(Math.max(...data.rateList))
        this.optionEqRepair.yAxis[0].max = Math.ceil(Math.max(...data.totalList)/a)*a
        this.optionEqRepair.yAxis[0].interval = Math.round(this.optionEqRepair.yAxis[0].max/5*100)/100
        this.optionEqRepair.yAxis[1].max = Math.ceil(Math.max(...data.rateList)/b)*b
        this.optionEqRepair.yAxis[1].interval = Math.round(this.optionEqRepair.yAxis[1].max/5*0.5)/0.5
      }, errMsg => {
        this.eqRepairLoading = false
        return this.$message.error(errMsg);
      })

      this.renderEcharts('eqRepairAccumulate',this.optionEqRepair)
      this.eqRepairLoading = false
    },


    renderEcharts(id,option){
      if (document.getElementById(id)) {
        echarts.init(document.getElementById(id)).dispose();
        let chart = echarts.init(document.getElementById(id));
        chart.setOption(option)
        //let _this = this
        /*let time
        //chart绑定滚动事件
        chart.on('dataZoom',function (params) {
          //滚动条事件添加防抖
          clearTimeout(time)
          time = setTimeout(()=>{
            _this.getWuJianChartData(params)
          },1000)
        })*/

      }
    },

  },

  created(){
  },

  mounted() {
    this.getEqStatusChart()
    this.getEqDeptChart()
    this.getEqTypeChart()
    this.getEqRepairChart()
  }
}
</script>

<style scoped>

.pageContainer{
  display: flex;
  flex-direction: row;
  overflow: hidden;
  width: 100%;
}

.asideContainer{
  width: 30%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}

.title{
  border-left: 3px solid steelblue;
  height: 25px;
  width: 80%;
  font-size: 16px;
  padding-left: 10px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.space-between{
  display: flex;
  flex-direction: row;
  align-items: center;;
}

.size{
  width: 100%;
  height: 440px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

</style>